module.exports = __webpack_public_path__ + "img/attendance-sms.c9dcd2e9.svg";